import {Sponsors} from "../../services/sponsors";
import { mutation } from "./mutations";

const handleError = err => {
  console.log("Error in videos action : ", err);
};

// Actions
export const getSponsorsListRequest = () => async dispatch => {
  try {
    let result = await Sponsors.requestSponsorsData();
    dispatch(mutation.setSponsorsList(result));
  } catch (err) {
    handleError(err);
  }
};
